import templateUrl from './designPlacer.tpl.html';
import PlacingEditor from './placingEditor/placingEditor';
import EventEmitter from 'common/eventEmitter';
import _ from 'common/customLodash';
import './designPlacer.scss';

const designPlacer = () => ({
    templateUrl: templateUrl,
    restrict: 'EA',
    replace: true,
    scope: {
        config: '=',
        init: '&'
    },
    bindToController: true,
    controller: 'DesignPlacerController',
    controllerAs: 'vm'
});

class DesignPlacerController {
    constructor() {
        'ngInject';
        this.events = new EventEmitter();
        this.editorSize = this.config.editorSize;
        this.colour = this.config.colour;
        this.editable = this.config.editable !== false;
        this.viewpoints = [];
        this.currentViewpoint = null;
        this.navDisabled = false;
        this.editorContainer = angular.element(document.getElementById('editors'));
        this.viewpointSelectors = angular.element(document.getElementById('viewpoint-selectors'));
        this.init({controller: this});
    }

    addViewpoint(options) {
        const viewpoint = _.extend({}, options);
        const container = this.createViewpointContainer(viewpoint.name);
        this.editorContainer.append(container);
        const selector = this.createViewpointSelector(viewpoint.name);
        this.viewpointSelectors.append(selector);
        viewpoint.editor = this.createEditor(viewpoint, container);
        viewpoint.editor.events.on('change', evt => this.onChange(evt));
        viewpoint.editor.events.on('instruction', evt => this.onInstruction(evt));
        viewpoint.selector = selector;
        this.viewpoints.push(viewpoint);
    }

    createViewpointContainer(name) {
        const viewpointContainer = angular.element(`<div id="${name}" class="viewpoint-editor"></div>`);
        viewpointContainer.css('display', 'none');
        return viewpointContainer;
    }

    createViewpointSelector(name) {
        const selectorName = `<span class="name">${name}</span>`;
        const selector =  `<div class="viewpoint" id="viewpoint-${name}"><div class="background"><img class="background-img"></div>${selectorName}</div>`;
        const viewpointSelector = angular.element(selector);
        viewpointSelector.on('click', () => this.selectViewpoint(name));
        return viewpointSelector;
    }

    createEditor(viewpoint, viewpointContainer) {
        const containerId = viewpointContainer.attr('id');
        return new PlacingEditor(containerId, this.editorSize, viewpoint, this.colour, this.editable);
    }

    selectViewpoint(viewpointName) {
        if (this.currentViewpoint === viewpointName || this.navDisabled) {
            return;
        }

        this.currentViewpoint = viewpointName;
        const viewpointContainers = this.editorContainer.children();
        _.forEach(viewpointContainers, viewpointContainer => {
            const element = angular.element(viewpointContainer);
            element.css('display', element.attr('id') === viewpointName ? 'block' : 'none');
        });
        const viewpointSelectors = angular.element(document.getElementById('viewpoint-selectors'));
        _.forEach(viewpointSelectors.children(), viewpointSelector => {
            const element = angular.element(viewpointSelector);
            element.attr('class', element.attr('id') === 'viewpoint-' + viewpointName ? 'viewpoint active' : 'viewpoint');
        });

        this.events.emit('selectviewpoint', {viewpointName: viewpointName});
    }

    getEditor(viewpointName) {
        const viewpoint = _.find(this.viewpoints, v => {
            return v.name === viewpointName;
        });

        return viewpoint.editor;
    }

    getSelector(viewpointName) {
        const viewpoint = _.find(this.viewpoints, v => {
            return v.name === viewpointName;
        });

        return viewpoint.selector;
    }

    addDesign(viewpointName, design) {
        const editor = this.getEditor(viewpointName);
        return editor.addDesign(design);
    }

    getDesigns(viewpointName) {
        const editor = this.getEditor(viewpointName);
        return editor.getDesigns();
    }

    setDesigns(viewpointName, designs) {
        const editor = this.getEditor(viewpointName);
        return editor.setDesigns(designs).then(() => {
            this.drawViewpointSelector(viewpointName);
        });
    }

    setBackground(viewpointName, imageUrl) {
        const editor = this.getEditor(viewpointName);
        editor.viewpoint.image = imageUrl;
        return editor.setBackground(imageUrl).then(() => {
            this.drawViewpointSelector(viewpointName);
            this.events.emit('change');
        });
    }

    disableNav(disabled) {
        this.navDisabled = disabled;
        const viewpointSelectors = this.viewpointSelectors.children();
        _.forEach(viewpointSelectors, viewpointSelector => {
            const element = angular.element(viewpointSelector);
            element.toggleClass('disabled', disabled);
        });
    }

    drawViewpointSelector(viewpointName) {
        const editor = this.getEditor(viewpointName);
        const imageData = editor.getImageData({width: 160, height: 160});
        const element = angular.element(this.getSelector(viewpointName));
        const background = element[0].getElementsByClassName('background-img')[0];
        background.src = imageData;
    }

    onChange(evt) {
        // Use update to trigger external state changes.
        // Use change for internal state changes.
        this.events.emit('update', evt);
        this.drawViewpointSelector(evt.viewpointName);
    }

    onInstruction(evt) {
        this.events.emit('instruction', evt);
    }
}

export default angular
    .module('designPlacer', [])
    .controller('DesignPlacerController', DesignPlacerController)
    .directive('designPlacer', designPlacer)
    .name;



// WEBPACK FOOTER //
// ./src/designPlacer.js